<template>
  <div class="progress-info">
    <div class="progress-left" @click="increase">
      <img :src="leftIcon" />
      <span>上一版</span>
    </div>
    <div class="progress-center">
      <el-progress
        :percentage="(currentVersionIndex / totalVersion.length) * 100"
        color="#0D59FA"
        stroke-width="8"
        :format="format"
      ></el-progress>
    </div>
    <div class="progress-right" @click="decrease">
      <span>下一版</span>
      <img :src="rightIcon" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import leftIcon from "@/assets/left_icon.png";
import rightIcon from "@/assets/right_icon.png";

const emits = defineEmits(["decreaseVersion", "increaseVersion"]);
const props = defineProps({
  totalVersion: Array,
  currentVersion: Object,
  currentVersionIndex: Number,
});

const format = () =>
  `${props.currentVersionIndex}/${props.totalVersion?.length}`;

//上一版
const increase = () => {
  emits("increaseVersion");
};
//下一版
const decrease = () => {
  emits("decreaseVersion");
};
</script>

<style scoped lang="scss">
.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.2rem;
  padding: 0.8rem 2rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
  border: 0.1rem solid #e9e9e9;
  .progress-left,
  .progress-right {
    width: 20%;
    line-height: 2.8rem;
    font-size: 1.4rem;
    cursor: pointer;
    img {
      width: 0.5rem;
      height: 0.9rem;
    }
    span {
      font-weight: 600;
      font-size: 1.4rem;
      margin-left: 1rem;
    }
  }
  .progress-right {
    span {
      margin-right: 1rem;
    }
  }
  .progress-center {
    width: 56%;
  }
}
:deep(.el-progress-bar__outer) {
  height: 0.8rem !important;
}
:deep(.el-progress__text) {
  font-size: 1.52rem !important;
}
</style>
